import { useGameStore } from '../stores/gameStore.js';

/**
 * jwt réactif brut — pour les composants qui décodent le token (claims,
 * sub, tid...) ou le passent tel quel à une fonction/action existante.
 */
export function useJwt(): string | null {
  return useGameStore((s) => s.jwt);
}

/**
 * Headers d'auth prêts à l'emploi pour fetch(). tenantId est optionnel car
 * le store n'a pas de champ tenantId canonique — chaque appelant garde sa
 * propre dérivation existante (JWT decode, hostname, currentZoneId...) et
 * la passe ici uniquement pour construire le header, sans que ce hook
 * n'impose ou ne duplique cette logique.
 */
export function useAuthHeaders(tenantId?: string): Record<string, string> {
  const jwt = useGameStore((s) => s.jwt);
  return tenantId
    ? { Authorization: `Bearer ${jwt}`, 'X-Tenant-ID': tenantId }
    : { Authorization: `Bearer ${jwt}` };
}
